'use strict';

exports.__esModule = true;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
exports.canUseDOM = canUseDOM;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.1.2@history/lib/ExecutionEnvironment.js
 ** module id = 199
 ** module chunks = 0
 **/